import styled from 'styled-components';


export const Wrapper = styled.div`
  .single-col {
    display: grid;
    grid-template-columns: 1fr;
  }
`;

export const Content = styled.div`
  width: 85%;
  margin: 40px auto;
`;

export const HeaderRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {max-width: 370px; margin: 0 1em;}

  button.go-action {
    width: 100px;
  }
`

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin: 40px 0 65px;
  grid-column-gap: 4%;

  &.cols-1 {
    grid-template-columns: 1fr;
  }

  h1 {
    text-align: center;
    text-transform: uppercase;
    font-size: 30px;
    font-weight: 900;
    font-style: italic;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }
  @media all and (max-width: 1200px) {
    display: flex;
    flex-direction: column;
   }
   @media all and (min-width: 993px) and (max-width: 1200px) {
    // unique to these breakpoints

   }
`;

export const ContentCol = styled.div`
  display: grid;
  grid-row-gap: 40px;

  @media all and (max-width: 992px) {
    margin-bottom: 2em;
   }
   @media all and (min-width: 993px) and (max-width: 1200px) {
    display: flex;
    flex-direction: row;
    margin-bottom: 2em;
   }
`;

export const SearchItemsList = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
  margin-top: 40px;
  width: 85%;
`

export const UserSearchItem = styled.div`
  height: 60px;
  width: 100%;
  border-radius: 6px;
  background-color: #2f2f2f;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .5rem 1rem;
  margin: .5em;
  max-width: 600px;

  button: {
    height: 40px;
  }

`


// WEBPACK FOOTER //
// ./src/pages/DataCenter/DataCentre.styles.ts